import React from 'react';

import { useSearchModal } from './useSearchModal';

import { 
  Wrapper, 
  Container, 
  List,
  MessageWrapper, 
  BtnWrap, SearchArea,
} from './styeld.js';

const SearchInputModal = ({ selectMyAddress, closeModal }) => {

  const {
    searchState, 
    onChangeInput, 
    clickAddress,
  } = useSearchModal(selectMyAddress, closeModal);

  return (
    <Wrapper>
      <Container>
        <div className="input-wrap"> 
            <svg width="17.76" height="17.76" viewBox="0 0 24 24">
              <g fill="none" fillRule="evenodd">
                <path d="M0 0H24V24H0z"/>
                <g stroke="#222222" strokeWidth="1.5" transform="translate(2 2)">
                  <circle cx="8" cy="8" r="8"/>
                  <path strokeLinecap="round" d="M15 14L19.95 18.95"/>
                </g>
              </g>
            </svg>

            <input 
              placeholder={ '예) 서초동, 삼청동, 방이동' } 
              value={searchState.input}
              onChange={onChangeInput.bind(null)}
            />
        </div>
        
        <List>
          {searchState.isLoading ? (
            <MessageWrapper>검색중</MessageWrapper>
          ) : searchState.inputResultList?.length > 0 ?
            searchState.inputResultList?.map((value, index) => (
              <div className='listItem' 
                onClick={clickAddress.bind(null,value)} 
                key={index}
              >
                <p>{value?.fullName}</p>
              </div>
              )
            ) : searchState.input ? (
              <MessageWrapper>검색결과가 없습니다</MessageWrapper>
            ) : (
              <MessageWrapper>주소를 검색해주세요</MessageWrapper> 
            )
          }
        </List>   
        
        <BtnWrap>
          <SearchArea onClick={closeModal}>닫기</SearchArea>
        </BtnWrap>
      </Container>
    </Wrapper>
  )
}

export default SearchInputModal;
